import React from 'react';
import PropTypes from "prop-types";
import { Icon } from 'antd';
import Loader from '../../assets/icons/loader.gif';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

export default function Preloader(props) {
	return (
		<div data-test="preLoaderBlock" className={props.styling ? props.styling : 'preloader'} >
			<img src={Loader} className={props.styling} alt='Loader' />
		</div>
	)
}

Preloader.propTypes = {
  styling: PropTypes.object
}
